module.exports = __webpack_public_path__ + "img/deposit_bitcoin.b73f240d.png";